module.exports = __webpack_public_path__ + "assets/shirk.d3227095.png";